import { useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import type { ActivePrompt } from "../../../types/PromptTypes";
import { promptCoverSrc } from "../../../utils/smileDesign/promptCoverSrc";

const SLIDE_STEP = 400;

interface SmileSelectorProps {
    value: string;
    prompts: ActivePrompt[];
    onChange: (value: string) => void;
}

export function SmileSelector({
    value,
    prompts,
    onChange,
}: SmileSelectorProps) {
    const scrollerRef = useRef<HTMLDivElement>(null);

    const prev = () => {
        const el = scrollerRef.current;
        if (!el) return;
        el.scrollLeft -= SLIDE_STEP;
    };

    const next = () => {
        const el = scrollerRef.current;
        if (!el) return;
        el.scrollLeft += SLIDE_STEP;
    };

    if (!prompts.length) {
        return <p className="text-sm text-[#6B6C72]">No active filters.</p>;
    }

    return (
        <div className="smile-filter-slider-wrap">
            <div ref={scrollerRef} className="smile-style-slider">
                {prompts.map((p) => {
                    const selected = String(p.id) === String(value);
                    const image = promptCoverSrc(p.filter_image || p.front_thumb);
                    return (
                        <button
                            key={p.id}
                            type="button"
                            className={`smile-filter-slide${selected ? " is-selected" : ""}`}
                            onClick={() =>
                                onChange(selected ? "" : String(p.id))
                            }
                        >
                            {image ? (
                                <img src={image} alt="" draggable={false} />
                            ) : (
                                <span className="smile-filter-slide-empty">No preview</span>
                            )}
                            <span className="smile-filter-slide-name">{p.name}</span>
                        </button>
                    );
                })}
            </div>
            <button
                type="button"
                className="smile-filter-control prev"
                aria-label="Previous filters"
                onClick={prev}
            >
                <FiChevronLeft size={18} />
            </button>
            <button
                type="button"
                className="smile-filter-control next"
                aria-label="Next filters"
                onClick={next}
            >
                <FiChevronRight size={18} />
            </button>
        </div>
    );
}
